import { useCallback, useEffect, useMemo } from "react";

import { DUNNINGS_POP_UP_CTA_LOCATION } from "app/components/Dunnings/dunningsConstants";
import type { DunningsButtonClickDestination } from "app/components/hooks/useDunnings";
import { useDunnings } from "app/components/hooks/useDunnings";
import { allTrackers } from "app/services/track/track";

interface IUseDunningsModalProps {
    eventName: string;
    eventSubSubName: string;
}

interface IUseDunningsModalApi {
    isOpen: boolean;
    onCloseClicked: () => void;
    onDunningsButtonClicked: (destination?: DunningsButtonClickDestination) => void;
}

export const useDunningsModal = ({ eventName, eventSubSubName }: IUseDunningsModalProps): IUseDunningsModalApi => {
    const {
        hasDunnings,
        isHomePageModalDiscarded,
        onHomePageModalDiscard,
        onDunningsButtonClicked: onDunningsButtonClickedFn,
    } = useDunnings();

    const isOpen = useMemo(() => !isHomePageModalDiscarded && hasDunnings, [isHomePageModalDiscarded, hasDunnings]);

    useEffect(() => {
        if (isOpen) {
            allTrackers.dispatchTrackEvent(
                DUNNINGS_POP_UP_CTA_LOCATION,
                "show",
                `${eventName}/${DUNNINGS_POP_UP_CTA_LOCATION}`,
            );
        }
    }, [eventName, isOpen]);

    const onCloseClicked = useCallback(() => {
        allTrackers.dispatchTrackEvent(
            DUNNINGS_POP_UP_CTA_LOCATION,
            "close",
            `${eventName}/${DUNNINGS_POP_UP_CTA_LOCATION}`,
        );
        onHomePageModalDiscard();
    }, [eventName, onHomePageModalDiscard]);

    const onDunningsButtonClicked = useCallback(
        (destination?: DunningsButtonClickDestination) => {
            onDunningsButtonClickedFn(`${eventName}/${DUNNINGS_POP_UP_CTA_LOCATION}/${eventSubSubName}`, destination);
        },
        [eventName, eventSubSubName, onDunningsButtonClickedFn],
    );

    return {
        isOpen,
        onCloseClicked,
        onDunningsButtonClicked,
    };
};
